export default __webpack_public_path__ + "static/media/Nitro-Bot-Example.85dba57f.png";